import { PaidMessages } from '$core/PaidMessages/PaidMessages';

export function Storage() {
  return <PaidMessages />;
}
